export const CREATE_CUSTOMER14860 = "CREATE_CUSTOMER14860";
export const UPDATE_CUSTOMER14860 = "UPDATE_CUSTOMER14860";
export const DELETE_CUSTOMER14860 = "DELETE_CUSTOMER14860";
export const FETCH_CUSTOMER14860 = "FETCH_CUSTOMER14860";
export const LISTEN_TO_SELECTED_CUSTOMER14860 =
  "LISTEN_TO_SELECTED_CUSTOMER14860";
export const FILTER_CUSTOMER14860 = "FILTER_CUSTOMER14860";
